import { gql } from '@apollo/client';

export default gql`
  query searchLocationsByPort(
    $port: String!
    $searchString: String!
    $pageSize: Int!
    $lastPageToken: LocationPageTokenInput
  ) {
    searchLocationByPort(
      port: $port
      searchString: $searchString
      pageSize: $pageSize
      lastPageToken: $lastPageToken
    ) {
      lastPageToken {
        id
        orderingIndexKey
        weight
      }
      locations {
        id
        port
        nameShort
        nameLong
        type
        aliases
        source
        customProperties {
          name
          value
        }
      }
    }
  }
`;
